import React from "react";

export const PageImage = (props) => {
    let {pageType, image, imageAlt} = props;
    return (
        <div id={`${pageType}-image-box`} className="page-image image app-part col-lg-6 col-md-6 col-sm-12">
            <img id={`${pageType}-image`} className={`${pageType}-image image`} src={image} alt={imageAlt}/>
        </div>
    )
};